import React, { Component } from 'react';
import connect from "react-redux/es/connect/connect";
import { Link } from "react-router-dom";
import CheckIcon from "material-ui/svg-icons/navigation/check";
import CloseIcon from "material-ui/svg-icons/navigation/close";

import { Datagrid, FilterForm, List } from 'components/list';
import { TextField } from 'components/field';
import TextInput from "components/input/TextInput";
import DateInput from "components/input/DateInput";

import FromTimestampToDateField from 'util/fields/FromTimestampToDateField';
import * as urls from './urls';
import * as utils from './utils';
import dayjs from "dayjs";
import { showNotification } from 'actions/notificationActions';
import { saveDataRecordSelected } from "actions/recordSelectedActions";
import FlatButton from "material-ui/FlatButton";
import ContentCreate from "material-ui/svg-icons/content/create";

const SetupRequestFilter = (props) => (
  <FilterForm {...props} initialValues={props.defaultSearchValue}>
    <DateInput source="airpay_linked_from" label="From"/>
    <DateInput source="airpay_linked_to" label="To"/>
    <TextInput source="shop_ids" label="Shop ID"/>
  </FilterForm>
);


const ServiceEnabledField = (props) => {
  const {epayment_service_code, record} = props;

  for (let setting of record.epayment_settings) {
    if (setting.epayment_service === epayment_service_code) {
      return setting.service_enabled ? <CheckIcon/> : <CloseIcon/>;
    }
  }
  return null;
};


class EditButton extends Component {
  saveCurrentRecordData = () => {
    this.props.dispatch(saveDataRecordSelected(utils.setupRequestResourceName, this.props.record));
  };

  render() {
    return (
      <div onClick={this.saveCurrentRecordData}>
        <FlatButton
          primary
          label='Edit'
          icon={<ContentCreate/>}
          containerElement={(<Link to={urls.setupRequestEditFrontendPath}/>)}
          style={{overflow: 'inherit'}}
        />
      </div>
    )
  }
}

const EditButtonConnected = connect()(EditButton);

class SetupRequestList extends Component {
  render() {
    const {filterValues} = this.props;
    let autoLoadData = false;
    if (filterValues && Object.keys(filterValues).length > 0) {
      autoLoadData = true;
    }

    return (
      <List
        {...this.props}
        hasCreate={false}
        filters={
          <SetupRequestFilter
            defaultSearchValue={filterValues}
          />
        }
        autoLoadData={autoLoadData}
        hasClearFilter={true}
        validateFilterForm={(filterValue) => {
          if (!filterValue['shop_ids']) {
            if (filterValue['airpay_linked_to'] && filterValue['airpay_linked_from']) {
              const daysDiff = dayjs(filterValue['airpay_linked_to']).diff(dayjs(filterValue['airpay_linked_from']), "day");
              if (daysDiff < 0) {
                this.props.dispatch(showNotification('Please select To date greater than From date', 'warning'));
                return false;
              } else if (daysDiff > 15) {
                this.props.dispatch(showNotification('Please select data within 15 days', 'warning'));
                return false;
              }
            } else {
              this.props.dispatch(showNotification('At least must enter condition From/To or Shop ID', 'warning'));
              return false;
            }
          }
          return true;
        }}
        updateFilterValueBeforeSearch={(filterValue) => {
          const newFilterValue = {...filterValue};
          if (!filterValue['shop_ids']) {
            delete newFilterValue['shop_ids'];
          }
          if (!filterValue['airpay_linked_after']) {
            delete newFilterValue['airpay_linked_after'];
          }
          if (!filterValue['airpay_linked_before']) {
            delete newFilterValue['airpay_linked_before'];
          }
          return newFilterValue;
        }}
      >
        <Datagrid bodyOptions={{stripedRows: true, showRowHover: true}}>
          <TextField source="shop_id" label="Shop ID"/>
          <FromTimestampToDateField
            format={'YYYY-MM-DD hh:mm:ss'} source="airpay_linked_on" label="AirPay First Linked On"
          />
          <ServiceEnabledField epayment_service_code={utils.EPAYMENT_SERVICE_AIRPAY} label="AirPay"/>
          <ServiceEnabledField epayment_service_code={utils.EPAYMENT_SERVICE_ALIPAY} label="Alipay"/>
          <ServiceEnabledField epayment_service_code={utils.EPAYMENT_SERVICE_WECHAT_PAY} label="WeChat"/>
          <EditButtonConnected/>
        </Datagrid>
      </List>
    )
  }
}

export default connect(
  state => ({
    filterValues: state.admin.filter[utils.setupRequestResourceName],
  })
)(SetupRequestList);



// WEBPACK FOOTER //
// ./src/routes/e_payment/SetupRequestList.js